import { useEffect, useState } from 'react';
import { mesNaClinica } from '@/dashboard/periodo';

/**
 * ★★★ WU-2/P8 — A TELA QUE FICA ABERTA ATRAVESSA A MEIA-NOITE.
 *
 * ⚠⚠⚠ O defeito que isto conserta, achado na medição da WU
 * (`docs/wu-reincidencia-1610.md` §8, item P7 de lá): `ProximosContatosPage` assinava
 * `ouvirMetas(clinicaId, mesNaClinica(new Date()), …)` com dependências
 * `[clinicaId, vejoOPlacar]`. ★★ O mês é calculado **na montagem** e as dependências **não
 * incluem o mês** — então uma aba montada em 31/10 continua assinando `metas/2026-10`
 * **para sempre**, e em 1º/11 o cartão de ritmo mostra a meta do mês passado.
 *
 * ★★★ E esta é justamente a tela que a SDR deixa aberta o dia inteiro — ⚠ o dono mediu que
 * elas usam **uma aba** e **fecham o Chrome**, mas fechar à noite não cobre quem atende até
 * depois da meia-noite, nem a aba que dorme com a máquina.
 *
 * ★ POR QUE SONDAGEM DE 1 MINUTO, e não um `setTimeout` até a meia-noite: ⚠⚠ um temporizador
 * longo **não** é confiável numa aba que dorme (a máquina suspende e o `setTimeout` acorda
 * tarde, sem ninguém conferir). ★★ A sondagem compara a chave do mês com a atual e só troca
 * o estado quando ela muda — custo de uma comparação de string por minuto, e ela **também**
 * acerta quando a máquina volta do sono.
 *
 * ⚠ O relógio é lido pela função injetada (`agora`), não por `new Date()` espalhado: é a
 * regra da WN, e é o que torna a virada testável com relógio falso.
 */
export const INTERVALO_VIRADA_MS = 60_000;

export function useMesAtual({ agora = () => new Date(), intervaloMs = INTERVALO_VIRADA_MS } = {}) {
  const [mes, setMes] = useState(() => mesNaClinica(agora()));

  useEffect(() => {
    const conferir = () => setMes((atual) => {
      const novo = mesNaClinica(agora());
      // ★ Devolver o MESMO valor não re-renderiza: a sondagem é invisível 1.439 vezes por dia.
      return novo === atual ? atual : novo;
    });
    conferir();
    const t = setInterval(conferir, intervaloMs);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervaloMs]);

  return mes;
}
